import React, { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import Button from '@material-ui/core/Button';

import { selectOrganisationSites } from '../../../../../../redux/selectors/organisation';

import Mesh from '../Mesh/Mesh';
import Add from '@material-ui/icons/Add';
import styles from '../EditFirePanel/EditFirePanel-styles.module.scss';
import classnames from 'classnames';
//redux
import { useDispatch, useSelector } from 'react-redux';
import { doGetMeshList } from '../../../../../../redux/thunks/mesh';
import { createFirePanel, firePanelList } from '../../../../../../redux/thunks/firepanel';
import Modal from '../../../../../../components/Modals/Modal';
import ButtonCustom from '../../../../../../components/Buttons/Button';
import SquareDelete from '../../../../../../components/SquareDelete/SquareDelete';
import TextInput from '../../../../../../components/Inputs/TextInput';
import Dropdown from '../../../../../../components/Inputs/Dropdown';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import Typography from '../../../../../../components/Typography/Typography';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import SButton from '../../../../../../components/SButton/SButton';
import { PlusIcon } from '@phosphor-icons/react';
import useIsMobile from '../../../../../../hooks/useIsMobile';
import { Dialog } from '@material-ui/core';
import SDialog from '../../../../../../components/SDialog/SDialog';

const CreateFirePanel = ({ togglePopup, useMesh }) => {
  //redux
  const dispatch = useDispatch();
  const isMobile = useIsMobile()
  const width70 = useIsMobile(1033)

  const { customerId } = useParams();
  const { sites } = useSelector((state) => ({
    sites: selectOrganisationSites(state),
  }));
  const meshData = useSelector((state) => state.mesh.meshIOs);

  const currentPartner = useSelector((state) => state.auth.currentPartner);
  //state
  const [disableButton, setDisableButton] = useState(true);

  // const [usedData, setUsedData] = useImmer(() => useMesh || {});

  const meshIOs = meshData || {};
  // const [noFuncMesh, setNoFuncMesh] = useImmer([]);
  const [firePanelData, setFirePanelData] = useState({
    name: '',
    siteId: '',
    meshIos: {},
  });

  const [network, setNetwork] = useState({ name: '', value: '' });

  const popupToggle = useCallback(() => {
    togglePopup && togglePopup();
  }, [togglePopup]);

  const handleChange = useCallback(
    (name, value) => {
      if (name === 'name') {
        setFirePanelData(prev => ({ ...prev, name: value }));
      } else if (name === 'site') {
        setFirePanelData(prev => ({
          ...prev,
          siteId: value,
          meshIos: {},
        }));
        setNetwork({ name: '', value: '' });
      }
    },
    [setFirePanelData],
  );

  // useEffect(() => {
  //   const arr = meshIOs.filter(
  //     (item) => item.function === 'no_function' && item.meshIOState === 'unassigned',
  //   );

  //   const a = [];
  //   for (const key in firePanelData.meshIos) {
  //     if (firePanelData.meshIos[key].serialNumber !== '') {
  //       a.push(firePanelData.meshIos[key].serialNumber);
  //     }
  //   }
  //   const filtered = intersection(arr, a);
  //   if (Object.keys(firePanelData.meshIos).length === 0) {
  //     setNoFuncMesh(arr);
  //   } else {
  //     setNoFuncMesh(filtered);
  //   }
  // }, [firePanelData.meshIos, firePanelData.siteId, meshIOs, setNoFuncMesh]);

  const getMeshList = useCallback(() => {
    if (currentPartner && customerId) dispatch(doGetMeshList(currentPartner.partnerId, customerId));
  }, [currentPartner, customerId, dispatch]);

  useEffect(() => {
    getMeshList();
  }, [getMeshList]);

  const addMesh = useCallback(() => {
    let last = Object.keys(firePanelData.meshIos).length - 1;
    if (last < 0) {
      last = 0;
    } else {
      last = last + 1;
    }
    setFirePanelData(prev => ({
      ...prev, meshIos: {
        ...prev?.meshIos,
        [last]: { serialNumber: '', pins: [], show: false, selected: [] }
      }
    }))
  }, [firePanelData.meshIos, setFirePanelData]);

  const deleteMesh = useCallback(
    (key) => {
      setFirePanelData(prev => {
        if (!prev?.meshIos) return prev;

        const updatedMeshIos = { ...prev.meshIos };
        delete updatedMeshIos[key];

        return { ...prev, meshIos: updatedMeshIos };
      });
    },
    [setFirePanelData],
  );

  const addPins = useCallback(
    (key, serialNumber) => {
      // const filtered = meshIOs.filter((item) => item.serialNumber === serialNumber);
      setFirePanelData((prev) => {
        return {
          ...prev,
          meshIos: {
            ...prev.meshIos,
            [key]: {
              ...prev.meshIos[key],
              serialNumber: serialNumber,
              pins: [
                {
                  id: 9,
                  name: 'DI.04',
                  type: 'DI',
                  number: 4,
                  isEnabled: false,
                },
                {
                  id: 10,
                  name: 'DI.03',
                  type: 'DI',
                  number: 3,
                  isEnabled: false,
                },
                {
                  id: 11,
                  name: 'DI.02',
                  type: 'DI',
                  number: 2,
                  isEnabled: false,
                },
                {
                  id: 12,
                  name: 'DI.01',
                  type: 'DI',
                  number: 1,
                  isEnabled: false,
                },
              ],
            },
          },
        };
      });
    },

    [setFirePanelData],
  );

  const getFilteredMesh = (serialNumber) => {
    const filtered = meshIOs.filter((item) => item.serialNumber === serialNumber);
    if (filtered.length > 0) {
      return filtered[0];
    } else {
      return {};
    }
  };

  const updatePinName = useCallback(
    (key, id, text) => {
      setFirePanelData((prev) => {
        return {
          ...prev,
          meshIos: {
            ...prev.meshIos,
            [key]: {
              ...prev.meshIos[key],
              pins: prev.meshIos[key].pins.map((it) =>
                it.id === id ? { ...it, name: text } : it
              ),
            },
          },
        };
      });
    },
    [setFirePanelData],
  );

  const hideShowMesh = useCallback(
    (key, status) => {
      setFirePanelData(prev => ({
        ...prev, meshIos: {
          ...prev?.meshIos,
          [key]: {
            ...prev?.meshIos[key],
            show: status
          }
        }
      }))
    },
    [setFirePanelData],
  );

  const updateMeshData = (key, id, status) => {
    setFirePanelData((prev) => {
      return {
        ...prev,
        meshIos: {
          ...prev.meshIos,
          [key]: {
            ...prev.meshIos[key],
            pins: prev.meshIos[key].pins.map((it) =>
              it.id === id ? { ...it, isEnabled: status } : it
            ),
          },
        },
      };
    });
  };

  const createNew = useCallback(() => {
    const body = {};
    body.name = firePanelData.name;
    body.siteId = firePanelData.siteId;
    const tempMesh = [];
    Object.keys(firePanelData.meshIos).map((key) => {
      const temp = {};
      temp.serialNumber = firePanelData.meshIos[key].serialNumber;
      const arr = firePanelData.meshIos[key].pins.filter((item) => item.type === 'DI');
      temp.pins = arr;
      tempMesh.push(temp);
      return null;
    });
    body.meshIOs = tempMesh;
    dispatch(
      createFirePanel(currentPartner.partnerId, network.id, customerId, body, (status) => {
        if (status === 'success') {
          togglePopup && togglePopup('success');
        }
      }),
    );
    dispatch(firePanelList(currentPartner.partnerId, customerId));
  }, [
    currentPartner.partnerId,
    customerId,
    dispatch,
    firePanelData.meshIos,
    firePanelData.name,
    firePanelData.siteId,
    network.id,
    togglePopup,
  ]);

  //disableButton
  useEffect(() => {
    if (Object.keys(firePanelData.meshIos).length > 0) {
      for (const key in firePanelData.meshIos) {
        if (firePanelData.meshIos.hasOwnProperty(key)) {
          if (firePanelData.meshIos[key].serialNumber === '') {
            setDisableButton(true);
            return;
          } else {
            setDisableButton(false);
          }

          firePanelData.meshIos[key].pins.map((item) => {
            if (item.name === '') {
              setDisableButton(true);
            }
            return null;
          });
        }
      }
    } else {
      setDisableButton(true);
    }
  }, [firePanelData.meshIos, setDisableButton]);

  const selectedSite = sites?.find((site) => site.id === firePanelData?.siteId);
  const filteredMeshData = meshData.filter((item) => item.networkId === network.id);

  const usedSerialNumbers = useMesh.flatMap((item) =>
    item.meshios.map((meshio) => meshio.serialNumber),
  );

  // Filter 'filteredMeshData' to remove the mesh IOs with used serial numbers
  const filteredUnusedMeshData = filteredMeshData.filter((meshItem) => {
    return !usedSerialNumbers.includes(meshItem.serialNumber);
  });

  return (
    <SDialog
      title='Create Fire Panel'
      open={true}
      isFormDialog={true}
      width={'45rem'}
      primaryButtonConfig={{
        text: 'Create',
        disabled: disableButton,
        onClick: () => {
          createNew();
        }
      }}
      secondaryButtonConfig={{
        text: 'Cancel',
        onClick: () => {
          popupToggle();
        }
      }}
      onClose={() => popupToggle(false)}
    >
      <FlexColumn alignItems='start' justifyContent='space-between'>
        <FlexColumn flexWrap='nowrap' justifyContent='start' alignItems='start' styles={{ height: '100%' }}>

          <FlexColumn styles={{ maxWidth: '95vw' }}>
            <TextInput
              placeholder="Fire Panel Name"
              name="name"
              onChange={(e) => handleChange('name', e.target.value)}
            />
            <Dropdown
              placeholder="Site"
              name="site"
              data={sites}
              value={selectedSite?.name}
              onChange={(e) => handleChange('site', e?.id)}
            />
            <Dropdown
              placeholder="Network"
              name="newtwork"
              data={selectedSite?.networks}
              value={network.name}
              onChange={(data) => {
                setNetwork({ ...data });
              }}
            />
          </FlexColumn>

          <FlexColumn>
            <FlexRow justifyContent='space-between' styles={{ marginTop: '1rem' }}>
              <Typography variant={"h7M"}>Select Mesh I/O</Typography>
              <SButton
                onClick={() => {
                  addMesh();
                }}
                disabled={
                  firePanelData.name === '' ||
                  firePanelData.siteId === '' ||
                  filteredUnusedMeshData.length === 0 ||
                  filteredUnusedMeshData.length === Object.keys(firePanelData.meshIos).length
                }
                variant={"secondary"}
                color={"grey"}>
                <PlusIcon size={18} style={{ marginRight: '0.5rem' }} /> Add Mesh I/O
              </SButton>
            </FlexRow>
          </FlexColumn>

          <div className={classnames(styles['container'])} style={{ padding: isMobile ? '0rem' : '0.5rem' }}>
            {Object.keys(firePanelData.meshIos).map((key, index) => {
              const mesh = getFilteredMesh(firePanelData.meshIos[key].serialNumber);
              const selectedvalue = mesh?.name ? mesh?.name : '';

              const filteredOptions = filteredUnusedMeshData.filter((option) => {
                const serialNumberMatch =
                  firePanelData.meshIos[key].serialNumber !== option.serialNumber;

                return serialNumberMatch;
              });

              return (
                <>
                  <div className="box-grey" style={isMobile ? { padding: '1rem 0.5rem' } : {}}>
                    <FlexRow alignItems='end' justifyContent='space-between'>
                      <FlexColumn width={isMobile ? 'fit-content' : '10rem'} styles={isMobile ? { flex: '1 1 100%', maxWidth: '100%' } : {}}>
                        <Dropdown
                          placeholder="Select Mesh I/O"
                          name="Mesh"
                          value={selectedvalue}
                          onChange={(e) => {
                            addPins(key, e.serialNumber);
                          }}
                          data={filteredOptions}
                        />
                      </FlexColumn>
                      <FlexRow width='fit-content' justifyContent={isMobile ? 'space-between' : 'center'} styles={isMobile ? { flex: '1 1 100%' } : {}}>
                        <SButton
                          type='secondary'
                          color={"grey"}
                          disabled={firePanelData.meshIos[key].serialNumber === ''}
                          onClick={() => {
                            hideShowMesh(key, !firePanelData.meshIos[key].show);
                          }}>
                          {firePanelData.meshIos[key].show ? 'Hide Details' : 'Show Details'}
                        </SButton>
                        <SquareDelete
                          color={'#ff535a'}
                          onPress={() => {
                            deleteMesh(key);
                          }}
                          style={{ width: '2.3rem', height: '2.3rem', padding: '0px', margin: '0' }}
                        />
                      </FlexRow>
                    </FlexRow>

                    {firePanelData.meshIos[key].show && (
                      <div className="mesh-container" style={{ marginTop: '1rem' }}>
                        <Mesh
                          isEditable
                          pinData={firePanelData.meshIos[key].pins}
                          handleChange={(id, status) => {
                            updateMeshData(key, id, status);
                          }}
                          onTextChange={(id, text) => {
                            updatePinName(key, id, text);
                          }}
                          isTextChangeable={true}
                        />
                      </div>
                    )}
                  </div>
                </>
              );
            })}
          </div>
        </FlexColumn>
      </FlexColumn>
    </SDialog>
  );
};

export default CreateFirePanel;
